export default __webpack_public_path__ + "static/media/detail_big_15_5.338ef266.jpg";